
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/components/AuthProvider";
import {
  HomeIcon,
  GanttChartIcon,
  Receipt,
  UserRound,
  Users,
} from "lucide-react";
import { cn } from "@/lib/utils";

export function MobileNavigation() {
  const { session } = useAuth();
  const location = useLocation();

  if (!session) return null;

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const navItems = [
    {
      name: "Dashboard",
      icon: HomeIcon,
      href: "/dashboard",
    },
    {
      name: "Projects",
      icon: GanttChartIcon,
      href: "/projects",
    },
    {
      name: "Clients",
      icon: Users,
      href: "/clients",
    },
    {
      name: "Invoices",
      icon: Receipt,
      href: "/invoices",
    },
    {
      name: "Profile",
      icon: UserRound,
      href: "/profile",
    },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 z-50 w-full h-16 bg-background border-t mobile-bottom-safe shadow-lg">
      <div className="grid h-full grid-cols-6">
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className={cn(
              "inline-flex flex-col items-center justify-center px-1 mobile-touch-target hover:bg-muted transition-colors",
              isActive(item.href) ? "text-primary font-medium" : "text-muted-foreground"
            )}
            aria-current={isActive(item.href) ? "page" : undefined}
          >
            <item.icon
              className={cn(
                "mb-1 w-5 h-5",
                isActive(item.href) ? "text-primary" : "text-muted-foreground"
              )}
            />
            <span className="text-xs">{item.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
